import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { MultiCheckboxModel } from 'src/app/Modelo/multiCheckboxModel';
import { TrackBy } from 'src/app/Modelo/trackBy';

@Component({
  selector: 'app-lista-multi-checkbox',
  templateUrl: './lista-multi-checkbox.component.html',
  styleUrls: ['./lista-multi-checkbox.component.scss']
})
export class ListaMultiCheckboxComponent<TKey> extends TrackBy implements OnInit {
  @Input() panelLabel: string = 'Seleccione una opción';
  @Input() mainCheckLabel: string = 'Todas las opciones';
  @Input() disabled: boolean = false;
  @Input() items: Array<MultiCheckboxModel<TKey>>;

  @Output() onChange: EventEmitter<Array<MultiCheckboxModel<TKey>>> = new EventEmitter<Array<MultiCheckboxModel<TKey>>>();

  constructor() {
    super();
   }

  ngOnInit(): void {
  }

  get hasItems(): boolean {
    return (this.items?.length ?? 0) > 0;
  }

  get allAreChecked(): boolean {
    return (this.items ?? new Array<MultiCheckboxModel<TKey>>()).every(i => i.checked);
  }

  changeAll(toSet: boolean): void {
    if ((this.items?.length ?? 0) > 0) {
      this.items.forEach((currentItem: MultiCheckboxModel<TKey>) => {
        currentItem.checked = toSet;
      });

      this.onValueChanged();
    }
  }

  onValueChanged(): void {
    this.onChange.emit(this.items.filter(i => i.checked));
  }
}
